import { render } from "./ContatoInfo.vue?vue&type=template&id=640e5f83&scoped=true&lang=pug"
import script from "./ContatoInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ContatoInfo.vue?vue&type=script&setup=true&lang=js"

import "./ContatoInfo.vue?vue&type=style&index=0&id=640e5f83&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640e5f83"]])

export default __exports__